var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "porder",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7415",
    "data-name": "Rectangle 7415",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11059",
    "data-name": "Path 11059",
    d: "M9,9V1h2V9h8v2H11v8H9V11H1V9ZM1,1H3V3H1ZM1,5H3V7H1Zm0,8H3v2H1Zm0,4H3v2H1ZM5,1H7V3H5ZM5,17H7v2H5ZM13,1h2V3H13Zm0,16h2v2H13ZM17,1h2V3H17Zm0,4h2V7H17Zm0,8h2v2H17Zm0,4h2v2H17Z",
    transform: "translate(2 2)",
    fill: "#1dbbbe",
    stroke: "#1dbbbe",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorder);
export default __webpack_public_path__ + "static/media/border.cb628c69624f0f652b916d9bec905a09.svg";
export { ForwardRef as ReactComponent };